(function() {
  function getNextWorkingDay(date) {
    let nextDay = new Date(date);
    nextDay.setDate(nextDay.getDate() + 1);
    while (nextDay.getDay() === 0 || nextDay.getDay() === 6) {
      nextDay.setDate(nextDay.getDate() + 1);
    }
    return nextDay;
  }

  function shouldShowTimer(currentDate) {
    const day = currentDate.getDay();
    const hour = currentDate.getHours();
    
    if ((day === 5 && hour >= 14) || day === 6 || (day === 0 && hour < 14)) {
      return false;
    }
    return true;
  }

  function getTimeUntilDeadline(currentDate, targetDate) {
    const diff = targetDate - currentDate;
    
    if (diff <= 0) {
      return { hours: 0, minutes: 0, seconds: 0 };
    }
    
    const hours = Math.floor(diff / (1000 * 60 * 60));
    const minutes = Math.floor((diff % (1000 * 60 * 60)) / (1000 * 60));
    const seconds = Math.floor((diff % (1000 * 60)) / 1000);
    
    return { hours, minutes, seconds };
  }

  function getDeliveryInfo(currentDate) {
    const day = currentDate.getDay();
    const hour = currentDate.getHours();
    const minutes = currentDate.getMinutes();
    
    let deliveryDate = new Date(currentDate);
    let message = "";
    let deadline = new Date(currentDate);
    deadline.setHours(14, 0, 0, 0);

    if (hour >= 14 || (hour === 14 && minutes >= 0)) {
      deadline = getNextWorkingDay(currentDate);
      deadline.setHours(14, 0, 0, 0);
    }

    switch(day) {
      case 4: // Jeudi
        if (hour >= 14) {
          deliveryDate.setDate(deliveryDate.getDate() + 4);
          message = "Livraison estimée en 4 jours";
        } else {
          deliveryDate.setDate(deliveryDate.getDate() + 2);
          message = "Livraison estimée en 2 jours";
        }
        break;
      
      case 5: // Vendredi
        if (hour >= 14) {
          deliveryDate.setDate(deliveryDate.getDate() + 5);
          message = "Livraison estimée en 5 jours";
        } else {
          deliveryDate.setDate(deliveryDate.getDate() + 3);
          message = "Livraison estimée en 3 jours";
        }
        break;
      
      case 6: // Samedi
        deliveryDate.setDate(deliveryDate.getDate() + 4);
        message = "Livraison estimée en 4 jours";
        break;
      
      case 0: // Dimanche
        deliveryDate.setDate(deliveryDate.getDate() + 3);
        message = "Livraison estimée en 3 jours";
        break;
      
      default: // Lundi, Mardi, Mercredi
        if (hour >= 14) {
          deliveryDate.setDate(deliveryDate.getDate() + 3);
          message = "Livraison estimée en 3 jours";
        } else {
          deliveryDate.setDate(deliveryDate.getDate() + 2);
          message = "Livraison estimée en 2 jours";
        }
    }

    const timeLeft = getTimeUntilDeadline(currentDate, deadline);

    return {
      message: message,
      date: deliveryDate,
      showTimer: shouldShowTimer(currentDate),
      hoursLeft: timeLeft.hours,
      minutesLeft: timeLeft.minutes,
      secondsLeft: timeLeft.seconds
    };
  }

  function updateDeliveryMessage() {
    const deliveryInfo = getDeliveryInfo(new Date());
    const deliveryText = document.getElementById('deliveryText');
    const dateText = document.getElementById('dateText');
    const countdownTimer = document.getElementById('countdownTimer');
    const timerWrapper = document.getElementById('timerWrapper');

    if (!deliveryText || !dateText || !countdownTimer || !timerWrapper) return;

    const formattedDate = deliveryInfo.date.toLocaleDateString('fr-FR', {
      weekday: 'long',
      day: 'numeric',
      month: 'long'
    });

    deliveryText.textContent = deliveryInfo.message;
    dateText.textContent = formattedDate;

    if (deliveryInfo.showTimer) {
      timerWrapper.style.display = 'inline';
      countdownTimer.textContent = 
        `${String(deliveryInfo.hoursLeft).padStart(2, '0')}:${String(deliveryInfo.minutesLeft).padStart(2, '0')}:${String(deliveryInfo.secondsLeft).padStart(2, '0')}`;
    } else {
      timerWrapper.style.display = 'none';
    }
  }

  // Initialize and update the timer
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function() {
      updateDeliveryMessage();
      setInterval(updateDeliveryMessage, 1000);
    });
  } else {
    updateDeliveryMessage();
    setInterval(updateDeliveryMessage, 1000);
  }
})();